export interface KeyDto {
  id: string;
  ownerId: string;
  status: KeyStatus;
  chatId: string | null;
  name: string | null;
  secret: string | null;
  permissions: ChatPermissions[];
}

export interface KeyRequest {
  id?: string;
  permissions: ChatPermissions[];
  name?: string;
}

export interface Key {
  id?: string;
  ownerId: string;
  status: KeyStatus;
  chatId?: string;
  name?: string;
  secret?: string;
  permissions: ChatPermissions[];
}

export function fromDtoToKey(dto: KeyDto): Key {
  return {
    id: dto.id,
    ownerId: dto.ownerId,
    status: dto.status,
    chatId: dto.chatId ?? undefined,
    name: dto.name ?? undefined,
    secret: dto.secret ?? undefined,
    permissions: dto.permissions,
  };
}

export type ChatPermissions =
  | 'read:chat-feed:oil'
  | 'read:chat-feed:gas'
  | 'read:chat-feed:dm-policy'
  | 'read:chat-feed:em-credit'
  | 'read:chat-feed:em-markets'
  | 'read:chat-feed:em-policy'
  | 'read:chat-feed:eu-credit'
  | 'read:chat-feed:us-credit'
  | 'read:chat-feed:global-macro'
  | 'read:chat-feed:newsfibullets'
  | 'read:chat-feed:newsfxbullets'
  | 'read:chat-feed:g10-markets'
  | 'read:chat-feed:power'
  | 'read:chat-feed:us-oil'
  | 'read:chat-feed:us-gas'
  | 'read:chat-feed:commodities-macro-addon';

export type KeyStatus = 'CREATED' | 'REVOKED' | 'ACTIVE' | 'INACTIVE';

export enum KeyStatusEnum {
  CREATED = 'CREATED',
  REVOKED = 'REVOKED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

type ExistingChatPermissions = {
  id: ChatPermissions;
  name: string;
  description: string;
};

export const existingChatPermissions: ExistingChatPermissions[] = [
  { id: 'read:chat-feed:oil', name: 'EU Oil', description: '' },
  { id: 'read:chat-feed:gas', name: 'EU Gas', description: '' },
  { id: 'read:chat-feed:dm-policy', name: 'DM Policy', description: '' },
  { id: 'read:chat-feed:em-credit', name: 'EM Credit', description: '' },
  { id: 'read:chat-feed:em-markets', name: 'EM Markets', description: '' },
  { id: 'read:chat-feed:em-policy', name: 'EM Policy', description: '' },
  { id: 'read:chat-feed:eu-credit', name: 'EU Credit', description: '' },
  { id: 'read:chat-feed:us-credit', name: 'US IG Credit', description: '' },
  { id: 'read:chat-feed:global-macro', name: 'Global Macro', description: '' },
  { id: 'read:chat-feed:newsfibullets', name: 'News Fi Bullets', description: '' },
  { id: 'read:chat-feed:newsfxbullets', name: 'News FX Bullets', description: '' },
  { id: 'read:chat-feed:g10-markets', name: 'G10 Markets', description: '' },
  { id: 'read:chat-feed:power', name: 'EU Power', description: '' },
  { id: 'read:chat-feed:us-oil', name: 'US Oil', description: '' },
  { id: 'read:chat-feed:us-gas', name: 'US Gas', description: '' },
  {
    id: 'read:chat-feed:commodities-macro-addon',
    name: 'Commodities Macro Addon',
    description: '',
  },
];
